// extracted by mini-css-extract-plugin
export default {"homehero":"Home_homehero__txrHD","mask":"Home_mask__Q3gHs","into_img":"Home_into_img__C7LTn","content":"Home_content__vnsBc","btn":"Home_btn__F6ow7"};